/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PeopleMeResponse
 */
export interface PeopleMeResponse {
  /**
   *
   * @type {string}
   * @memberof PeopleMeResponse
   */
  email: string;
  /**
   *
   * @type {boolean}
   * @memberof PeopleMeResponse
   */
  isLeadership: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof PeopleMeResponse
   */
  permissions: Array<string>;
  /**
   *
   * @type {string}
   * @memberof PeopleMeResponse
   */
  keyDatesPath?: string | null;
}

/**
 * Check if a given object implements the PeopleMeResponse interface.
 */
export function instanceOfPeopleMeResponse(
  value: object,
): value is PeopleMeResponse {
  if (!("email" in value) || value["email"] === undefined) return false;
  if (!("isLeadership" in value) || value["isLeadership"] === undefined)
    return false;
  if (!("permissions" in value) || value["permissions"] === undefined)
    return false;
  return true;
}

export function PeopleMeResponseFromJSON(json: any): PeopleMeResponse {
  return PeopleMeResponseFromJSONTyped(json, false);
}

export function PeopleMeResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PeopleMeResponse {
  if (json == null) {
    return json;
  }
  return {
    email: json["email"],
    isLeadership: json["isLeadership"],
    permissions: json["permissions"],
    keyDatesPath:
      json["keyDatesPath"] == null ? undefined : json["keyDatesPath"],
  };
}

export function PeopleMeResponseToJSON(json: any): PeopleMeResponse {
  return PeopleMeResponseToJSONTyped(json, false);
}

export function PeopleMeResponseToJSONTyped(
  value?: PeopleMeResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    email: value["email"],
    isLeadership: value["isLeadership"],
    permissions: value["permissions"],
    keyDatesPath: value["keyDatesPath"],
  };
}
